<template>
  <div class="right_col" id="driver_add" role="main">
    <div class="row">
      <div class="col-md-12 col-sm-6 col-xs-12">
        <div class="title_left">
          <h3>新增司機</h3>
          <hr />
        </div>
      </div>
    </div>
    <div class="col-md-8">
      <form @submit="onInsertBtnClick" class="row">
        <div class="col-md-12">
          <div class="driverTitle">
            <h4>車隊資料</h4>
          </div>
          <div class="row margin10">
            <div class="form-group">
              <label
                class="control-label col-md-2 col-sm-2 col-xs-12"
                for="first-name"
              >
                呼號/隊編
                <span>*</span>
              </label>
              <div class="col-md-3 col-sm-3 col-xs-12">
                <input
                  v-model="driver.call_number"
                  id="inputSuccess2"
                  placeholder="隊編必填"
                  type="text"
                  required=""
                  class="form-control col-md-7 col-xs-12"
                  data-callNumber
                />
              </div>
            </div>
          </div>
          <div class="row margin10">
            <div class="form-group">
              <label
                class="control-label col-md-2 col-sm-2 col-xs-12"
                for="first-name"
              >
                計程車種類
                <span>*</span>
              </label>
              <div class="col-md-3 col-sm-3 col-xs-12">
                <select
                  @change="onDriverTypeChange"
                  v-model="driver.type"
                  id="taxiType"
                  class="form-control"
                  required=""
                >
                  <option :value="0">一般計程車</option>
                  <option :value="1">多元計程車</option>
                </select>
              </div>
            </div>
          </div>
          <div class="driverTitle">
            <h4>司機基本資料</h4>
          </div>
          <div class="row margin10">
            <div class="form-group">
              <label
                class="control-label col-md-2 col-sm-2 col-xs-12"
                for="first-name"
              >
                司機姓名
                <span>*</span>
              </label>
              <div class="col-md-3 col-sm-3 col-xs-12">
                <input
                  v-model="driver.name"
                  type="text"
                  class="form-control"
                  id="inputSuccess4"
                  placeholder="司機姓名必填"
                  required=""
                  data-username
                />
              </div>
              <label
                class="control-label col-md-2 col-sm-2 col-xs-12"
                for="first-name"
              >
                司機性別
                <span>*</span>
              </label>
              <div class="col-md-3 col-sm-3 col-xs-12">
                <select
                  id="gender"
                  v-model="driver.gender"
                  class="form-control"
                  required=""
                >
                  <option :value="0">男</option>
                  <option :value="1">女</option>
                </select>
              </div>
            </div>
          </div>
          <div class="row margin10">
            <div class="form-group">
              <label
                class="control-label col-md-2 col-sm-2 col-xs-12"
                for="first-name"
              >
                電話號碼/帳號
                <span>*</span>
              </label>
              <div class="col-md-3 col-sm-3 col-xs-12">
                <input
                  v-model="driver.phone"
                  type="text"
                  class="form-control"
                  pattern="[0-9]{10}"
                  placeholder="電話必填"
                  required=""
                  title="請輸入手機10位數"
                  data-phone
                />
              </div>
              <label
                class="control-label col-md-2 col-sm-2 col-xs-12"
                for="first-name"
              >
                密碼
                <span>*</span>
              </label>
              <div class="col-md-3 col-sm-3 col-xs-12">
                <input
                  v-model="driver.password"
                  type="password"
                  class="form-control"
                  placeholder="司機密碼必填"
                  required=""
                  data-password
                />
              </div>
            </div>
          </div>
          <div class="row margin10">
            <div class="form-group">
              <label
                class="control-label col-md-2 col-sm-2 col-xs-12"
                for="first-name"
              >
                聯絡電話1
              </label>
              <div class="col-md-3 col-sm-3 col-xs-12">
                <input
                  v-model="driver.contact1"
                  type="text"
                  class="form-control"
                  placeholder="聯絡電話1"
                  data-contact1
                />
              </div>
              <label
                class="control-label col-md-2 col-sm-2 col-xs-12"
                for="first-name"
              >
                聯絡電話2
              </label>
              <div class="col-md-3 col-sm-3 col-xs-12">
                <input
                  v-model="driver.contact2"
                  type="text"
                  class="form-control"
                  placeholder="聯絡電話2"
                  data-contact2
                />
              </div>
            </div>
          </div>
          <div class="row margin10">
            <div class="form-group">
              <label class="control-label col-md-2 col-sm-2 col-xs-12">
                電子信箱
              </label>
              <div class="col-md-3 col-sm-3 col-xs-12">
                <input
                  v-model="driver.email"
                  type="text"
                  class="form-control"
                  placeholder="電子信箱"
                  data-email
                />
              </div>
              <label class="control-label col-md-2 col-sm-2 col-xs-12">
                身分字號
                <span>*</span>
              </label>
              <div class="col-md-3 col-sm-3 col-xs-12">
                <input
                  v-model="driver.identify"
                  type="text"
                  class="form-control col-md-6"
                  placeholder="身分字號必填"
                  required=""
                  data-identify
                />
              </div>
            </div>
          </div>
          <div class="row margin10">
            <div class="form-group">
              <label class="control-label col-md-2 col-sm-2 col-xs-12">
                生日
              </label>
              <div class="col-md-3 col-sm-3 col-xs-12">
                <input
                  v-model="driver.birthday"
                  type="date"
                  class="form-control"
                  placeholder="生日"
                  data-email
                />
              </div>
            </div>
          </div>
          <div class="row margin10">
            <div class="form-group">
              <label class="control-label col-md-2 col-sm-2 col-xs-12">
                戶籍地址
                <span>*</span>
              </label>
              <div class="col-md-6 col-sm-6 col-xs-12">
                <input
                  v-model="driver.resident_address"
                  type="text"
                  class="form-control"
                  placeholder="戶籍地址必填"
                  required=""
                  data-residentAddress
                />
              </div>
            </div>
          </div>
          <div class="row margin10">
            <div class="form-group">
              <label class="control-label col-md-2 col-sm-2 col-xs-12">
                通訊地址
              </label>
              <div class="col-md-6 col-sm-6 col-xs-12">
                <input
                  v-model="driver.address"
                  type="text"
                  class="form-control"
                  placeholder="通訊地址"
                  data-address
                />
              </div>
            </div>
          </div>
          <div class="driverTitle">
            <h4>車輛資訊</h4>
          </div>
          <div class="row margin10">
            <div class="form-group">
              <label class="control-label col-md-2 col-sm-2 col-xs-12">
                營業執照
              </label>
              <div class="col-md-3 col-sm-3 col-xs-12">
                <input
                  v-model="driver.business_license"
                  type="text"
                  class="form-control col-md-6"
                  placeholder="營業執照"
                  data-bussinessLicense
                />
              </div>
              <label class="control-label col-md-2 col-sm-2 col-xs-12">
                製造車廠必填
                <span>*</span>
              </label>
              <div class="col-md-3 col-sm-3 col-xs-12">
                <input
                  v-model="driver.car_brand"
                  type="text"
                  class="form-control"
                  placeholder="製造車廠必填"
                  required=""
                  data-carBrand
                />
              </div>
            </div>
          </div>
          <div class="row margin10">
            <div class="form-group">
              <label class="control-label col-md-2 col-sm-2 col-xs-12">
                車牌必填
                <span>*</span>
              </label>
              <div class="col-md-3 col-sm-3 col-xs-12">
                <input
                  v-model="driver.licence"
                  type="text"
                  class="form-control"
                  placeholder="車牌必填"
                  required=""
                  data-licence
                />
              </div>
            </div>
            <div class="form-group">
              <label class="control-label col-md-2 col-sm-2 col-xs-12">
                可載座位數
                <span>*</span>
              </label>
              <div class="col-md-3 col-sm-3 col-xs-12">
                <input
                  v-model="driver.available_seat"
                  type="text"
                  class="form-control"
                  placeholder="可載座位數"
                  required=""
                />
              </div>
            </div>
          </div>
          <div class="row margin10">
            <div class="form-group">
              <label class="control-label col-md-2 col-sm-2 col-xs-12">
                領牌日
              </label>
              <div class="col-md-3 col-sm-3 col-xs-12">
                <input
                  v-model="driver.receive_car_license_date"
                  type="date"
                  class="form-control"
                  placeholder="生日"
                  data-email
                />
              </div>
            </div>
            <div class="form-group">
              <label class="control-label col-md-2 col-sm-2 col-xs-12">
                出廠日
              </label>
              <div class="col-md-3 col-sm-3 col-xs-12">
                <input
                  v-model="driver.car_leave_factory_date"
                  type="date"
                  class="form-control"
                  placeholder="生日"
                  data-email
                />
              </div>
            </div>
          </div>
          <div class="row margin10">
            <div class="form-group">
              <label class="control-label col-md-2 col-sm-2 col-xs-12">
                職業駕照發照日
              </label>
              <div class="col-md-3 col-sm-3 col-xs-12">
                <input
                  v-model="driver.professional_driver_license_date"
                  type="date"
                  class="form-control"
                  placeholder="生日"
                  data-email
                />
              </div>
            </div>
          </div>
          <div class="row margin10">
            <div class="form-group">
              <label class="control-label col-md-2 col-sm-2 col-xs-12">
                裝錶日
              </label>
              <div class="col-md-3 col-sm-3 col-xs-12">
                <input
                  v-model="driver.install_taxi_meter_date"
                  type="date"
                  class="form-control"
                  placeholder="生日"
                  data-email
                />
              </div>
            </div>
          </div>
          <div class="driverTitle">
            <h4>服務項目</h4>
          </div>
          <div class="row">
            <div class="col-md-12 col-md-12">
              <driver-service-checkbox
                ref="driverServiceList"
              ></driver-service-checkbox>
            </div>
          </div>
          <div class="row" v-if="permisionAddDriver">
            <div class="col-md-12 col-md-12">
              <button type="submit" class="mybtnstyle btn-dark col-md-3">
                新增司機
              </button>
              <button
                type="button"
                @click="onCancelBtnClick"
                class="mybtnstyle btn-danger col-md-3"
              >
                取消
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>

    <div class="col-md-4 col-xs-12">
      <div class="x_panel">
        <div class="x_title">
          <h4>權限狀態</h4>
          <div class="clearfix"></div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <select
              id="authorize"
              v-model="driver.authorize"
              class="form-control"
              required=""
            >
              <option :value="0">正常授權</option>
              <option :value="1">停權</option>
              <option :value="2">審核中</option>
            </select>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <p>*正式授權後將會開啟司機使用手機接單的權限</p>
            <p>*停權後將會關閉司機使用手機接單的權限</p>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-4 col-xs-12">
      <div class="x_panel">
        <div class="x_title">
          <h4>APP方案選擇</h4>
          <div class="clearfix"></div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <select
              id="plan"
              v-model="driver.plan"
              class="form-control"
              required=""
            >
              <option :value="0">電話叫車/APP/Line</option>
              <option :value="1">APP/Line</option>
            </select>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <p>*車隊叫車包含：商家叫車與電話叫車</p>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-4 col-xs-12">
      <div class="x_panel">
        <div class="x_title">
          <h4>填寫車隊客服備註-最多50字元</h4>
          <div class="clearfix"></div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <textarea
              v-model="driver.team_company_note"
              cols="50"
              rows="3"
              class="col-md-10 form-control textareastyle"
            ></textarea>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-4 col-xs-12">
      <div class="x_panel">
        <div class="x_title">
          <h4>填寫司機備註(乘客看得到)-最多50字元</h4>
          <div class="clearfix"></div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <textarea
              v-model="driver.note"
              cols="50"
              rows="3"
              class="col-md-10 form-control textareastyle"
            ></textarea>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import driverServiceCheckbox from '../../components/driver/DriverServiceCheckBox_1'
import BehaviorRecorder from '@/assets/js/libs/BehaviorRecorder'
import Driver from '@/assets/js/libs/Driver'
import { Notification } from 'element-ui'
import { getAdminAuthorization } from '../../assets/js/tool/adminAuth'

const driver = new Driver()

export default {
  name: 'AddDriver',
  components: {
    driverServiceCheckbox,
  },
  data() {
    return {
      driver: {
        call_number: null,
        group_id: null,
        name: null,
        phone: null,
        type: 0,
        email: null,
        gender: 0,
        password: null,
        identify: null,
        licence: null,
        car_brand: null,
        business_license: null,
        car_year: null,
        address: null,
        resident_address: null,
        authorize: 0,
        note: null,
        service: [],
        team_company_note: null,
        available_seat: 4,
        plan: 0,
        contact1: '',
        contact2: '',
        birthday: null,
        receive_car_license_date: null,
        car_leave_factory_date: null,
        professional_driver_license_date: null,
        registration_certificate_date: null,
        install_taxi_meter_date: null,
      },
    }
  },
  computed: {
    permisionAddDriver() {
      return getAdminAuthorization('addDriver') === 2
    },
  },
  methods: {
    async onInsertBtnClick(event) {
      try {
        event.preventDefault()
        this.driver.service = this.$refs.driverServiceList.getServiceList()
        this.driver.available_seat = parseInt(this.driver.available_seat)
        this.driver.car_year = '2000'
        BehaviorRecorder.record(
          '點擊',
          '司機資料',
          `新增司機-${this.driver.call_number}`,
        )
        const { success, message } = await driver.create(this.driver)
        if (success) {
          Notification({
            type: 'success',
            message: '新增司機成功',
          })
          this.$router.replace({ name: 'driverList' })
        } else {
          Notification({
            type: 'error',
            message: message,
          })
        }
      } catch (e) {
        console.error(e)
        Notification({
          type: 'error',
          message: '新增司機失敗',
        })
      }
    },
    onDriverTypeChange() {
      this.driver.service = []
      this.$refs.driverServiceList.setClearingServiceListActive()
    },
    onCancelBtnClick() {
      this.$router.replace({ name: 'driverList' })
    },
    onCarYearChange(val) {
      this.$refs.driverServiceList.onSetNewCar(val)
    },
  },
}
</script>

<style scoped>
h4 {
  min-width: 140px;
}

input.inputstyle {
  min-width: 240px;
}
.margin10 {
  margin-bottom: 10px;
}
.driverTitle {
  display: inline-block;
}
h4 {
  font-size: 18px;
  background-color: bisque;
  padding-top: 5px;
}
.fareImput {
  display: inline-block;
}
.showFare {
  background-color: #e8fcea;
}
</style>



// WEBPACK FOOTER //
// src/pages/driver/AddDriver.vue